import React, { useEffect } from "react";
import { Switch } from "react-router-dom";
import { useSelector } from "react-redux";
import Pages from "./layouts/Pages";
import Dashboard from "./layouts/Dashboard";
import { Login } from "./sec/Login";
import Recuperar from "./sec/recuperar";
import { app } from "./gen/General";
import { RoutesPagesGen } from "./gen/RoutesPagesGen";
import { Demo } from "./layouts/Demo";
import { Perfil } from "./user/Perfil";
import "react-table/react-table.css";
import "animate.css";
import { JedaiIdle } from "./coms/JedaiIdle";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { Registro } from "./Registro/Registro";
import { RedBeneficios } from "./beneficios/RedBeneficios";
import { CompTipoBeneficios } from "./beneficios/CompTipoBeneficios";
import { Prestadores } from "./prestadores/Prestadores";
import { GeneralHome } from "./pages/home/GeneralHome";
import { HOME_PATH } from "./components/Navbars/navbar.constants";

const pages = [
    {
        path: "/",
        name: "Login",
        icon: "users_circle-08",
    },
    {
        path: "/recuperar",
        name: "Recuperar",
        icon: "ui-1_lock-circle-open",
    },
    {
        path: "/registrarse",
        name: "Registro",
        icon: "ui-1_lock-circle-open",
    },
];

Sentry.init({
    dsn: "https://8a85dcff432f4be087c4e98ecee403ca@o398175.ingest.sentry.io/6194678",
    integrations: [new BrowserTracing()],
    release: process.env.REACT_APP_CURRENT_GIT_SHA,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
});

const App = () => {
    const user = useSelector(state => state.user);

    useEffect(() => {
        if (app.prod) {
            const s = document.createElement("script");
            s.type = "text/javascript";
            s.src = "https://www.googletagmanager.com/gtag/js?id=UA-121476452-3";
            document.body.appendChild(s);

            const s2 = document.createElement("script");
            s2.type = "text/javascript";
            s2.innerHTML =
                "window.dataLayer = window.dataLayer || [];\n" +
                "                        function gtag(){dataLayer.push(arguments);}\n" +
                "                        gtag('js', new Date());\n" +
                "\n" +
                "                        gtag('config', 'UA-121476452-3');";
            document.body.appendChild(s2);
        }
    }, []);

    return user?.id ? (
        <>
            <JedaiIdle />
            <Switch>
                <Dashboard exact path={HOME_PATH} component={GeneralHome} title={"Inicio"} />
                <Dashboard exact path="/demo" component={Demo} hideBg={true} />
                <Dashboard exact path="/perfil/:id?" component={Perfil} title={"Datos del Asegurado"} />
                <Dashboard
                    exact
                    path="/list/beneficios/:tp"
                    component={Prestadores}
                    title={"Beneficios por Aseguradora/Plan"}
                />
                <Dashboard
                    exact
                    path="/list/prestadores/:tp"
                    component={Prestadores}
                    title={"Beneficios por Aseguradora/Plan"}
                />
                <Dashboard
                    exact
                    path="/list/beneficios/:tp/:id"
                    component={RedBeneficios}
                    title={"Beneficios por Aseguradora"}
                />
                <Dashboard
                    exact
                    path="/list/beneficios/:tp/:id/:red"
                    component={CompTipoBeneficios}
                    title={"Beneficios por Red"}
                />
                <RoutesPagesGen />
            </Switch>
        </>
    ) : (
        <Switch>
            <Pages exact path="/login" routes={pages} component={Login} />
            <Pages exact path="/estados" routes={pages} component={Demo} />
            <Pages exact path="/login/:hash" routes={pages} component={Login} />
            <Pages exact path="/recuperar" routes={pages} component={Recuperar} />
            <Pages exact path="/registro" routes={pages} component={Registro} />
            <Pages routes={pages} component={Login} />
        </Switch>
    );
};

export default App;
